import Phaser from "phaser";
import { makePlaceholders } from "@/assets/placeholders";

export class BootScene extends Phaser.Scene {
  constructor() {
    super("Boot");
  }

  create(): void {
    makePlaceholders(this);
    this.scene.start("Preload");
  }
}
